import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "url", "previewIcon", "previewImage", "previewFallback"]

  switch(event) {
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.value !== event.currentTarget.value
    })
    this.refresh()
  }

  color({ params: { hex } }) {
    this.element.style.setProperty("--icon-picker-color", hex)
  }

  ignore(event) {
    event.preventDefault()
  }

  refresh() {
    const source = this.element.querySelector(".icon-picker__tab .icon-picker__radio:checked")?.value
    const icon = this.element.querySelector(".icon-picker__option .icon-picker__radio:checked")
    const url = this.urlTarget.value.trim()

    const showIcon = Boolean(source === "icon" && icon)
    const showImage = Boolean(source === "url" && url)

    if (showIcon) this.previewIconTarget.innerHTML = icon.nextElementSibling.innerHTML
    if (showImage) this.previewImageTarget.src = url

    this.previewIconTarget.hidden = !showIcon
    this.previewImageTarget.hidden = !showImage
    this.previewFallbackTarget.hidden = showIcon || showImage
  }
}
